module.exports = __webpack_public_path__ + "img/hero3.85f7a74b.jpg";